import React from 'react'
import ThemifyIconContainer from '../../../Components/Icons/ThemifyIcon'

export default function ThemifyIcon() {
  return (
    <div className='page-body'>
        <ThemifyIconContainer/>
    </div>
  )
}
